import { combineReducers } from "@reduxjs/toolkit";
import CompanyAdminReducer from "./reducers/CompanyAdminReducer";
import apiReducer from "./reducers/APIReducer";
import SuperAdminReducer from "./reducers/SuperAdminReducer";
import AppReducer, { LOGOUT } from "./reducers/AppReducer";
import { localpersistConfig } from "./store";
import EmployeeReducer from "./reducers/EmployeeReducer";

const appReducer = combineReducers({
    App: AppReducer,
    api: apiReducer,
    superAdmin: SuperAdminReducer,
    companyAdmin: CompanyAdminReducer,
    Employee: EmployeeReducer,
});


const rootReducer = (state, action) => {
    if (action.type === LOGOUT) {
        localpersistConfig.storage.removeItem(`persist:${localpersistConfig.key}`);

        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;

